"use server";

import {
    BusinessServiceProxy,
    MobileTimesheetWorkDayResultDto,
    MobileCategoryDto,
    MobilePartnersDto,
    CustomerServiceProxy,
    MobileServiceProxy,
    MobileCustomerProfileDto,
    MobileTimesheetDto,
    MobileCustomerProfileTimeDto,
    MobileCustomerProfileTransactionDto,
    SearchServiceProxy,
    TimesServiceProxy, MobileBusinessProfileDto
} from "./shared/service-proxies/service-proxies";
import {AppConsts} from "../core/AppConsts";
import {AxiosConfigure} from "../core/AxiosConfigure";
import {DateTime} from "ts-luxon";
import {cache} from "react";
import {BusinessService} from "../services/business-service";
import {validate as isUuid} from "uuid";
import {StoreService} from "../services/store-service";
import {useDebouncedCallback} from "use-debounce";
import { IpgServiceProxy } from "./shared/service-proxies/service-proxies";
import {
    MobileTimesheetBookTimeDto,
    MobileTimesheetBookTimeResultDto,
  } from "./shared/service-proxies/service-proxies";

  
const ipgService = new IpgServiceProxy(AppConsts.appBaseUrl, AxiosConfigure.getInstance());


const customerService = new CustomerServiceProxy(AppConsts.appBaseUrl, AxiosConfigure.getInstance());


const mobileService = new MobileServiceProxy(AppConsts.appBaseUrl, AxiosConfigure.getInstance());

const searchService = new SearchServiceProxy(AppConsts.appBaseUrl, AxiosConfigure.getInstance());

const timesService = new TimesServiceProxy(AppConsts.appBaseUrl, AxiosConfigure.getInstance());

const businessService = new BusinessServiceProxy(AppConsts.appBaseUrl, AxiosConfigure.getInstance());



export async function bookTimeWithDetails(
    onDate: string,
    fromTime: string,
    toTime: string,
    categoryId: number,
    partnerId: number
  ): Promise<string> {
    try {
      const dto = MobileTimesheetBookTimeDto.fromJS({
        onDate,
        fromTime,
        toTime,
        categoryId,
        partnerId,
      });
  
      const result = await timesService.booktime(dto);
  
      if (!result.trackingNumber) {
        throw new Error("کد پیگیری از سرور دریافت نشد.");
      }
  
      return result.trackingNumber;
    } catch (error) {
      console.error("❌ خطا در ثبت تایم:", error);
      throw new Error("رزرو تایم انجام نشد. لطفاً دوباره تلاش کنید.");
    }
  }
  


/**
 * ✅ گرفتن آدرس پرداخت برای هدایت کاربر به درگاه
 * @param trackingNumber شماره پیگیری رزرو
 * @returns URL درگاه پرداخت
 */
export async function requestPaymentUrl(trackingNumber: number): Promise<string> {
    try {
        const url = await ipgService.paymentRequest(trackingNumber);
        if (!url) {
            throw new Error("آدرس درگاه پرداخت یافت نشد.");
        }
        return url;
    } catch (error) {
        console.error("❌ خطا در گرفتن آدرس درگاه پرداخت:", error);
        throw new Error("خطا در دریافت آدرس پرداخت. لطفاً دوباره تلاش کنید.");
    }
}



/**
 * ✅ دریافت لیست تراکنش‌های کاربر به عنوان یک Server Action
 * 📦 با استفاده از کش برای بهینه‌سازی درخواست‌ها
 */
export const getTransactions = cache(async (): Promise<MobileCustomerProfileTransactionDto[]> => {
    try {
        return await customerService.transactions(); // `fromJS` قبلاً در `processTransactions` اجرا شده است
    } catch (error) {
        console.error("❌ خطا در دریافت تراکنش‌های کاربر:", error);
        if (error instanceof Error) {
            throw new Error(`خطایی در دریافت تراکنش‌های کاربر رخ داده است: ${error.message}`);
        }
        throw new Error("خطایی ناشناخته در دریافت تراکنش‌های کاربر رخ داده است.");
    }
});

export const getCustomerProfile = cache(async (): Promise<MobileCustomerProfileDto> => {
    try {
        return await mobileService.customerGet();
    } catch (error) {
        console.error("❌ خطا در دریافت پروفایل مشتری:", error);
        throw new Error("خطایی در دریافت اطلاعات مشتری رخ داده است. لطفاً دوباره تلاش کنید.");
    }
});

/**
 * ✅ بروزرسانی پروفایل کاربر به عنوان یک Server Action
 * @param updatedProfile اطلاعات جدید پروفایل
 * @returns پروفایل بروزرسانی شده
 */
export async function updateUserProfile(updatedProfile: MobileCustomerProfileDto): Promise<MobileCustomerProfileDto> {
    try {
        return await mobileService.customerPost(updatedProfile);
    } catch (error) {
        console.error("❌ خطا در بروزرسانی پروفایل کاربر:", error);
        throw new Error("بروزرسانی پروفایل انجام نشد. لطفاً دوباره تلاش کنید.");
    }
}


/**
 * ✅ دریافت نتایج جستجو به عنوان یک Server Action
 * @param query متن جستجو
 * @returns داده‌های پردازش شده از API
 */
export async function searchQuery(query: string) {
    try {
        const results = await searchService.query(query);

        // 🔥 پردازش داده‌های API قبل از ارسال به UI
        return {
            categories: results.categories ?? [],
            partners: results.partners ?? [],
            popular: results.popular ?? [],
        };
    } catch (error) {
        console.error("❌ خطا در دریافت نتایج جستجو:", error);
        throw error;
    }
}


/**
 * ✅ دریافت لیست تایم‌های کاربر به عنوان یک Server Action
 * MobileCustomerProfileTimeDto وضیفش اینجا برای گرفتن دیتاهست
 * ولی توی کامپوننت ReservedTimes   برای مشخص کردن type هست بجای interface
 */

export async function getCustomerTimes(): Promise<MobileCustomerProfileTimeDto[]> {
    try {
        return await customerService.times();
    } catch (error) {
        console.error("❌ خطا در دریافت تایم‌های کاربر:", error);
        throw new Error("خطایی در دریافت تایم‌های کاربر رخ داده است. لطفاً دوباره تلاش کنید.");
    }
}


/**
 * ✅ دریافت لیست تایم‌های کاربر به عنوان یک Server Action
 */
export async function getTimes(): Promise<MobileCustomerProfileTimeDto[]> {
    try {
        const times = await customerService.times();
        return times;
    } catch (error) {
        console.error("❌ خطا در دریافت تایم‌های کاربر:", error);
        throw new Error("خطایی در دریافت تایم‌های کاربر رخ داده است. لطفاً دوباره تلاش کنید.");
    }
}


export async function getTimesheet(onDate: string, categoryId?: number, partnerId?: number): Promise<MobileTimesheetDto[]> {
    try {
        // ✅ تبدیل `onDate` به `DateTime`
        const dateTime = DateTime.fromISO(onDate);
        if (!dateTime.isValid) {
            throw new Error("فرمت تاریخ نامعتبر است.");
        }

        // ✅ ارسال درخواست به API و دریافت داده‌های پردازش‌شده
        // @ts-ignore
        const result = await timesService.timesheet(dateTime, categoryId, partnerId);

        // 🔥 بررسی مقدار خروجی
        if (!result || result.length === 0) {
            return [];
        }

        return result;
    } catch (error) {
        console.error("❌ خطا در دریافت تایم‌شیت:", error);
        throw new Error("خطا در دریافت تایم‌شیت. لطفاً دوباره تلاش کنید.");
    }
}


/**
 * دریافت لیست شرکا از API
 * @returns لیست شرکا به فرمت `MobilePartnersDto[]`
 */
export async function getPartners(): Promise<MobilePartnersDto[]> {
    const bs = new BusinessService();
    const businessProfile = StoreService.GetData("business-profile") as MobileBusinessProfileDto;
  
    let result: MobilePartnersDto[] = localStorage.getItem("partners") as unknown as MobilePartnersDto[];
  
    if (!result) {
      const partners = await bs.getPartners();
  
      for (const partner of partners) {
       
        if (partner.profile) {
          try {
            const data = await bs.getFile(partner.profile, businessProfile.accessKey);
            partner.profile = "data:image/jpeg;base64," + data;
          } catch (error) {
            console.log("❌ Error loading profile image:", error);
          }
        }
  
     
        const gallery: string[] = [];
  
        if (Array.isArray(partner.gallery)) {
          for (const imageId of partner.gallery) {
            try {
              const data = await bs.getFile(imageId, businessProfile.accessKey);
              gallery.push("data:image/jpeg;base64," + data);
            } catch (error) {
              console.log("❌ Error loading gallery image:", error);
            }
          }
        }
  
        partner.gallery = gallery;
      }
  
      localStorage.setItem("partners", JSON.stringify(partners));
      return partners;
    }
  
    return result;
  }
  


/**
 * ✅ دریافت لیست دسته‌بندی‌ها به عنوان یک Server Action
 * @param accessToken توکن دسترسی
 * @returns لیست دسته‌بندی‌ها
 */
export const getCategories = cache(async (accessToken: string): Promise<MobileCategoryDto[]> => {
    try {
        const categories = await businessService.categories(accessToken);
        if (!Array.isArray(categories)) {
            throw new Error("داده‌های دریافت‌شده برای دسته‌بندی‌ها نامعتبر است.");
        }
        return categories; // داده‌ها به صورت آماده بازگردانده می‌شوند
    } catch (error) {
        console.error("❌ خطا در دریافت دسته‌بندی‌ها:", error);
        if (error instanceof Error) {
            throw new Error(`خطا در دریافت دسته‌بندی‌ها: ${error.message}`);
        }
        throw new Error("خطای ناشناخته در دریافت دسته‌بندی‌ها.");
    }
});


export const getWorkday = cache(async (): Promise<MobileTimesheetWorkDayResultDto[]> => {
    try {

        const data = await timesService.workday();

        if (!Array.isArray(data)) {
            throw new Error("ساختار داده‌های دریافتی از سرور معتبر نیست.");
        }

        const processedData = data.map(item => {
            return item;
        });

        return processedData;
    } catch (error) {
        console.error("❌ خطا در دریافت تاریخ‌های کاری:", error);


        if (error instanceof Error) {
            throw new Error(`خطایی در دریافت تاریخ‌های کاری رخ داده است: ${error.message}`);
        }
        throw new Error("خطایی ناشناخته در دریافت تاریخ‌های کاری رخ داده است.");
    }
});

